<template>
  <a-modal :title="$t('page_ops_machine_remove_machine')" :visible="visible" @cancel="cancel">
    <a-select
      allowClear
      show-search
      :getPopupContainer="triggerNode => triggerNode.parentNode"
      :placeholder="$t('search')"
      :value="customerId"
      :default-active-first-option="false"
      :show-arrow="false"
      :filter-option="false"
      :not-found-content="null"
      @focus="handleCustomerSearch"
      @search="handleCustomerSearch"
      @change="handleCustomerChange"
      style="width: 100%;margin-bottom: 8px;"
    >
      <a-select-option v-for="d in customerList" :key="d.value">
        {{ d.text }}
      </a-select-option>
    </a-select>
    <div class="movetree-boxs">
      <a-tree
          :tree-data="treeData"
          :defaultSelectedKeys="['00-00']"
          :defaultExpandAll="true"
          :selectedKeys.sync="value"
          @select="selectTree"
          :replaceFields="{children:'children', title: 'name', key: 'code'}"
      />    
    </div>
    <template slot="footer">
      <a-button key="back" @click="cancel">
        {{ $t('cancel') }}
      </a-button>
      <a-button
        :disabled="!value.length"
        key="submit"
        type="primary"
        :loading="loading"
        @click="ok"
      >
        {{ $t('ok') }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { CustomerServiceProxy } from '@/service-proxies/app-v2/masterlink-cps-client.service-proxies'
const csp = new CustomerServiceProxy()
import { getTenantInfo } from '@/utils/auth'
let timeout;
let currentValue;
function fetchCustomers(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function getCustomers() {
    csp.getCustomers(value).then((result) => {
      if (currentValue === value) {
        const data = [];
        result.forEach((r) => {
          data.push({
            value: r["id"],
            text: r["name"],
          });
        });
        callback(data);
      }
    });
  }
  timeout = setTimeout(getCustomers, 120);
}
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          console.log(225546)
          this.getTreeList()
          fetchCustomers('', (data) => (this.customerList = data));
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      treeData: [],
      value: [],
      customerList: [],
      loading: false,
      customerId: undefined,
      customerInfo: {},
    }
  },
  created() {
    this.getTreeList()
    fetchCustomers('', (data) => (this.customerList = data));
  },
  methods: {
    async getTreeList() {
      const tenant = getTenantInfo()
      const tenantCode = tenant ? tenant : '根节点'
      const treeData = [
         {
           code: '00-00',
           id: 0,
           name: tenantCode,
           level: 0,
         }
      ]
      const { data } = await csp.getRegionCustomerDetail();
      treeData[0].children = data;
      this.treeData = treeData;
    },
    selectTree(value) {
      this.value = value
    },
    cancel() {
      this.reload()
      this.$emit('cancel')
    },
    ok() {
      const customer = this.customerList.find((res) => {
        if (res !== undefined) return res.value == this.value[0]
      })
      if (customer) {
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 3000)
        this.reload()
        console.log(111, customer)
        this.$emit('ok', customer.value)
      }
    },
    reload() {
      this.treeData = []
      this.value = []
      this.customerList = []
      this.customerId =''
    },
    handleCustomerSearch(value) {
      value = value === undefined ? undefined : value;
      fetchCustomers(value, (data) => (this.customerList = data));
    },
    handleCustomerChange(value) {
      value = value === undefined ? undefined : value;
      this.customerId = value;
      fetchCustomers(value, (data) => (this.customerList = data));
      // id 获取地址
      this.customerInfo = this.customerList.find(v=>v.value===value);
      this.value = [this.customerInfo.value+'']
      document.getElementsByClassName('ant-tree-node-content-wrapper').forEach(res => {
        if (res.innerText === this.customerInfo.text) {
          res.scrollIntoView()
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.movetree-boxs {
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #d8d8d8;
}
/deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  width: 100%;
  background-color: #fff1b8;
}
/deep/ .ant-tree li .ant-tree-node-content-wrapper {
  width: 100%;
}
</style>
